/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line

import { Divider, Button, message } from 'antd'

// import SimplePopover from '../../../components/SimplePopover'

import { userStore } from '../../../store/list/UserModel'
import { userAction } from '../../../action/user'

const onChangeUserStatus = (uid: any, action: string) => {
  userAction.setUserStatus(uid, action)
    .then(responseData => {
      message.info('设置用户状态成功')
      userStore.reloadCurrentPage()
    })
    .catch((err) => {
      message.warning(err.message)
    })
}

export default (props: { text: any, record: any }) => {
  return <span>
    <Button type="primary" size="small" onClick={() => { onChangeUserStatus(props.record.id, 'active') }}>激活</Button>
    <Divider type="vertical" />
    <Button type="danger" size="small" onClick={() => { onChangeUserStatus(props.record.id, 'disabled') }}>拉黑</Button>
  </span>
}
